import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {BehaviorSubject, catchError, filter, Observable, throwError} from "rxjs";
import {Router} from "@angular/router";
import {getToken} from "../../../auth/selectors/auth.selector";
import {Store} from "@ngrx/store";
import {first, switchMap, take} from "rxjs/operators";
import {logout} from "../../../auth/actions/auth.actions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../auth/services/auth.service";
import * as fromAuth from '../../../auth/reducers/auth.reducer';
import {LoginResponseDto} from "../../../auth/models/auth.model";


@Injectable({
  providedIn: 'root'
})
export class ApplicationInterceptor implements HttpInterceptor{

  private token$: Observable<string>;
  private refreshTokenSubject = new BehaviorSubject<any>(null);

  private snackBar: MatSnackBar;

  constructor(
    snackBar: MatSnackBar,
    private router: Router,
    private store: Store<fromAuth.State>,
    private authService: AuthService
  ) {
    this.snackBar = snackBar;
    this.token$ = this.store.select(getToken);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.token$.pipe(
      first(), // Non voglio che al cambiare del token partano altre richieste uguali a quella ricevuta
      switchMap(token => {
        const authReq = !!token
          ? request.clone({
            setHeaders: { Authorization: 'Bearer ' + token },
          })
          : request;
        return next.handle(authReq);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handle401Error(request, next);
        } else {
          let errorMessage = '';
          switch (error.status) {
            case 0:
              if (navigator.onLine) {
                errorMessage = 'server non disponibile';
              } else {
                errorMessage = 'internet non disponibile';
              }
              break;
            case 403:
              if (request.url.includes('refresh')) {
                this.store.dispatch(logout());
              } else if (!request.url.includes('login')) {
                errorMessage = 'Non hai i permessi per eseguire questa operazione';
              } else {
                return throwError(error);
              }
              break;
            default:
              errorMessage = `${error?.error?.message ? error.error?.message : error?.message}`;
              break;
          }
          if (errorMessage) {
            this.snackBar.open(errorMessage, 'OK', { duration: 2000 });
          }
          return throwError(errorMessage);
        }
      })
    );
  }

  private static addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    console.log(localStorage.getItem('isRefreshing'));

    if (localStorage.getItem('isRefreshing') != 'true') {
      this.refreshTokenSubject.next(null);

      return this.authService.refreshTokens().pipe(
        switchMap((loginResponseDto: LoginResponseDto) => {
          this.refreshTokenSubject.next(loginResponseDto.token.jwt);
          return next.handle(ApplicationInterceptor.addToken(request, loginResponseDto.token.jwt));
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(ApplicationInterceptor.addToken(request, jwt));
        })
      );
    }
  }
}
